import { NgIf } from '@angular/common';
import { Directive, Input, inject } from '@angular/core';

import { UserPermission, UserRole } from '../../users/ model/user.model';
import { AuthService } from '../auth/services/auth.service';

@Directive({ selector: '[hasRole], [hasPermission]', standalone: true, hostDirectives: [NgIf] })
export class HasRoleDirective {
  private ngIf = inject(NgIf, { host: true });
  private authService = inject(AuthService);

  /**
   * Role or roles to validate
   */
  @Input('hasRole') set role(roleOrRoles: UserRole | UserRole[] | undefined) {
    this.toggleTemplate(!roleOrRoles || this.authService.hasAnyRole(roleOrRoles));
  }

  /**
   * Permission or permissions to validate
   */
  @Input('hasPermission') set isAdmin(permissionOrPermissions: UserPermission | UserPermission[] | undefined) {
    this.toggleTemplate(!permissionOrPermissions || this.authService.hasAnyPermission(permissionOrPermissions));
  }

  constructor() {}

  /**
   * Show/hide host element
   * @param isVisible whether to show to host
   */
  private toggleTemplate(isVisible: boolean) {
    this.ngIf.ngIf = isVisible;
  }
}
